import { useEffect, useMemo, useState } from 'react';
import axios from '../../../../../../../api/axios';
import { addHashTagRoute, deleteHashTagRoute } from '../../../../../../../api/routes';
import { toast } from 'react-toastify';
import ModuleTextInput from '../../components/ModuleTextInput';

const SPAM_COMMAND = 'SPAM_CHAT';

const getHashtagText = (hashtag) => typeof hashtag === 'string' ? hashtag : hashtag?.hashtag;

/**
 * Spam hashtags are campaign command data rather than customisation data. This
 * keeps the canvas inspector in sync with the same SPAM_CHAT values edited by
 * the legacy editor.
 */
const SpamHashtagField = (props) => {
    const campaign = props.campaignData;
    const feature = props.selectedFeatureNode?.featureData;
    const featureId = feature?._id || props.selectedFeatureNode?.id;
    const templateId = feature?.feature?._id;
    const commandEntry = useMemo(() => (campaign?.hashtagCommands || []).find((entry) =>
        entry?.command === SPAM_COMMAND &&
        (entry.featureID === featureId || entry.featureID === templateId)
    ), [campaign?.hashtagCommands, featureId, templateId]);
    const entryHashtags = (commandEntry?.hashtags || []).map(getHashtagText).filter(Boolean);
    const [savedHashtags, setSavedHashtags] = useState(entryHashtags);
    const savedHashtag = savedHashtags[0] || '';
    const [value, setValue] = useState(savedHashtag);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setSavedHashtags(entryHashtags);
        setValue(entryHashtags[0] || '');
    }, [commandEntry]);

    const save = async (_fieldId, nextValue) => {
        const hashtag = String(nextValue || '').trim();
        if (hashtag === savedHashtag || saving || !campaign?._id || !featureId) return;

        setSaving(true);
        try {
            const existing = savedHashtags;
            const param = commandEntry?.param ?? null;

            for (const existingHashtag of existing) {
                await axios.post(deleteHashTagRoute, {
                    campaignID: campaign._id,
                    featureID: featureId,
                    featureTemplateID: templateId,
                    command: SPAM_COMMAND,
                    param,
                    hashtag: { hashtag: existingHashtag },
                });
            }

            if (hashtag) {
                await axios.post(addHashTagRoute, {
                    campaignID: campaign._id,
                    featureID: featureId,
                    featureTemplateID: templateId,
                    command: SPAM_COMMAND,
                    param,
                    commandParam: param,
                    hashtag: { hashtag, cooldown: 0, restricted: false },
                });
            }

            setSavedHashtags(hashtag ? [hashtag] : []);
            toast.success('Spam hashtag updated');
        } catch (error) {
            setValue(savedHashtag);
            toast.error(error?.response?.data?.message || 'Unable to update spam hashtag');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <div className={`v2-module-field-label${saving ? ' disabled' : ''}`}>Spam Hashtag</div>
            <ModuleTextInput
                value={value}
                fieldId="spam-hashtag"
                enabled={!saving}
                editable={true}
                maxLength={100}
                onChange={save}
            />
        </>
    );
};

export default SpamHashtagField;
